/**
 * @file header-actions.js
 */

/* globals getApp */
import {get, post} from '@/utils/decorate/request';
import {Url} from '@/utils/api.js';
import {notAllowScroll, allowScroll} from '@/utils/decorate/scroll';


export default {
    getUserInfo({commit, state}, userType) {
        return get(Url.userInfoUrl, userType)
            .then(data => {
                commit('setUserInfo', data);
            })
            .catch(() => {
                state.isLogin = false;
                location.assign(state.openSourceProgram);
            });
    },
    openConfig({commit}) {
        commit('open');
        // 禁止页面滑动
        notAllowScroll();
    },
    hideConfig({commit}) {
        commit('hide');
        // 解绑禁止页面滚动事件
        allowScroll();
    },
    navTo({state}, name) {
        switch (name) {
            case 'Docs':
                window.open(state.openSourceDocs);
                break;
            case 'Smart':
                location.assign(state.smartProgram);
                break;
            case 'Manager':
                window.open(state.smartManager);
            case 'openSource':
                location.assign(state.openSourceProgram);
        }
    },

    /**
     * 登录函数
     */
    navToPassport({state, dispatch}) {
        let passportUrl = state.smartPassport;
        let currentUrl = encodeURIComponent(location.href);
        location.assign(passportUrl + currentUrl);
    },
    navToExit({state}) {
        get(Url.userLogout).then(() => {
            window.location.href = `http://cas.baidu.com/?action=logout&u=${location.origin}/opensource/index.html`;
        });
    },
    countLength({commit, rootState}) {
        commit('countLength', rootState.common.wordLimit.nicknameMaxLen);
    }
};
